var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoVideoShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 264,
    height: 104,
    viewBox: "0 0 264 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BEC4CE",
    fillRule: "nonzero",
    d: "M52 0h152a8 8 0 0 1 8 8v88a8 8 0 0 1-8 8H52a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8zm0 4a4 4 0 0 0-4 4v88a4 4 0 0 0 4 4h152a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H52zm69.69 35.075l18.62 11.85c.933.593.933 1.556 0 2.15l-18.62 11.85c-.933.593-1.69.183-1.69-.916V39.99c0-1.091.757-1.51 1.69-.916zM258 26h4a2 2 0 0 1 0 4h-4v4a2 2 0 0 1-4 0v-4h-4a2 2 0 0 1 0-4h4v-4a2 2 0 0 1 4 0v4zM10 66h4a2 2 0 0 1 0 4h-4v4a2 2 0 0 1-4 0v-4H2a2 2 0 0 1 0-4h4v-4a2 2 0 0 1 4 0v4zm11 17h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 1 1 2 0v2zm8-72h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2V9a1 1 0 1 1 2 0v2zm212 32h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 1 1 2 0v2zm-3 47h4a2 2 0 0 1 0 4h-4v4a2 2 0 0 1-4 0v-4h-4a2 2 0 0 1 0-4h4v-4a2 2 0 0 1 4 0v4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVideoShape);
export default __webpack_public_path__ + "static/media/no-video-shape.763aa3a8adbe4bcdfed5c466ef975f19.svg";
export { ForwardRef as ReactComponent };